export default require('./ProgressBarLive').default
